module.exports = __webpack_public_path__ + "img/ng_square_off_icon.fd31bd1a.svg";